<template>
	<div>
		<template v-if="menuOpen">
			<div id="blockScreen" class="block-screen" v-on:click="closeMenu"></div>
		</template>
		<div class="header-wrapper">
			<Menu></Menu>
			<RemoteHeader v-bind:heading="$t('remoteHeader')" v-bind:isBeta="false"></RemoteHeader>
		</div>
		<div id="ar-remote-page" class="page mt-global" v-bind:class="{ nonScroll: menuOpen }">
			<Remote></Remote>
		</div>
	</div>
</template>

<script>
import Remote from '@/components/Remote.vue';
import Menu from '@/components/Menu.vue';
import RemoteHeader from '@/components/RemoteHeader.vue';
import { setVersionIntervalTimer, clearVersionIntervalTimer } from '../versionUpgradeCheck.js';

export default {
	name: 'RemotePage',
	components: {
		Menu,
		RemoteHeader,
		Remote
	},
	props: [],
	data: function () {
		return ar.state;
	},
	methods: {
		handleWindowFocus() {
			// Reinitialize the recorder when the window (re-)gains focus
			ar.recorder.init();
			// Set up regular polling to see if the version has been upgraded
			setVersionIntervalTimer();
		},
		handleWindowBlur() {
			// Release the recorder when the window loses focus
			ar.recorder.release();
			// Clear the version upgrade polling interval
			clearVersionIntervalTimer();
		},
		closeMenu: function () {
			if (this.menuOpen) {
				this.menuOpen = false;
			}
		}
	},
	computed: {},
	beforeRouteEnter(to, from, next) {
		// We're navigating here from elsewhere within the app
		ar.recorder.init();
		// Set up regular polling to see if the version has been upgraded
		setVersionIntervalTimer();
		next();
	},
	beforeRouteLeave (to, from, next) {
		// We're about to navigate elsewhere within the app
		ar.recorder.release();
		// Clear the version upgrade polling interval
		clearVersionIntervalTimer();
		next();
	},
	mounted: function () {
		// Use localStorage not the state (ar.isCompanionMode) because the login will cause a page refresh which will set the state to false
		let isCompanionMode = false;
		if (ar.isLocalStorageAvailable('localStorage')) {
			isCompanionMode = ar.getLocalBoolean('companionMode');
		}

		if (isCompanionMode) {
			// Don't actually show remote page
			// Send /api/v1/companion/request ajax call to server
			// Redirect to "thanks for logging in. now go to companion app" page.
			const companionId = ar.getLocal('companionId');
			ar.saveCompanionPairing(companionId);
			ar.logout();
			arRouter.push('/companion-success');
		} else {
			// We're in normal mode, not custom mode
			ar.setState({
				customMode: false
			});
			if (ar.isLocalStorageAvailable('localStorage')) {
				ar.saveLocal('customMode', 'false');
			}
		}
		window.focusPageHeading();
		window.setPageTitle('');
		// Set up event listeners for window focus and blur
		window.addEventListener('focus', this.handleWindowFocus);
		window.addEventListener('blur', this.handleWindowBlur);
		ar.recorder.init();
	},
	beforeUnmount() {
		// Release the recorder before we're unmounted
		ar.recorder.release();
		// Remove event listeners to prevent memory leaks
		window.removeEventListener('focus', this.handleWindowFocus);
		window.removeEventListener('blur', this.handleWindowBlur);
	}
};
</script>

<style lang="scss" scoped>
.page {
	position: absolute;
	height: 100%;
	width: 100%;
}

.header-wrapper {
	display: flex;
	flex-direction: row;
	background-color: black;
    justify-content: flex-end;
}
</style>
